// src/common/services/acheteTerrainService.js
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
  const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
    if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
    acc[k] = Array.isArray(v) ? v.join(',') : v;
    return acc;
  }, {});
  const qs = new URLSearchParams(cleaned).toString();
  return qs ? `?${qs}` : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // ---- Sites ----
  listSites: (params) => exeRequest(`/admin/sites${buildQuery(params)}`, 'GET'),
  createSite: (data) => exeRequest('/admin/sites', 'POST', data),
  getSiteById: (id) => exeRequest(`/admin/sites/${id}`, 'GET'),
  updateSite: (id, data) => exeRequest(`/admin/sites/${id}`, 'PUT', data),
  deleteSite: (id, { force = false } = {}) =>exeRequest(`/admin/sites/${id}${buildQuery({ force })}`, 'DELETE'),
  recomputeNombreLots: (id) => exeRequest(`/admin/sites/${id}/recompute`, 'PATCH'),

  // ---- Lots (dans un site) ----
  addLot: (siteId, data) => exeRequest(`/admin/sites/${siteId}/lots`, 'POST', data),
  updateLot: (siteId, lotId, data) =>exeRequest(`/admin/sites/${siteId}/lots/${lotId}`, 'PUT', data),
  deleteLot: (siteId, lotId, { force = false } = {}) =>exeRequest(`/admin/sites/${siteId}/lots/${lotId}${buildQuery({ force })}`, 'DELETE'),
  importLotsJson: (siteId, lots) =>exeRequest(`/admin/sites/${siteId}/lots/import`, 'POST', { lots }),
};
